<div class="row">
	<div class="col-sm-2 node-panel">
		<div style="margin: 10px 20px 0px 40px; display: block">
		 	<h3 style="position: absolute; left: 35px; top: 5px"><i class="fa fa-pencil" aria-hidden="true"></i></h3>
	  		<input type="text" class="form-control input-lg workflow-name" id="ruleName" placeholder="WORKFLOW NAME">
		</div>
	
		<div class="form-group" style="margin: 20px">
		  <textarea class="form-control" rows="2" id="comment" placeholder="Description"></textarea>
		</div>
	
		<div class="pull-right btn-group" style="margin: 0px 20px 0px 20px">
		  <button type="button" class="btn btn-primary"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save as Draft</button>
		  <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
			<span class="caret"></span>
		  </button>
		  <ul class="dropdown-menu" role="menu">
			<li><a href="#">Save & Deploy</a></li>
			<li><a href="#">Save in Test Mode</a></li>
			<li class="divider"></li>
			<li><a href="#">Reset Workflow</a></li>
			<li><a href="#">Delete Workflow</a></li>
	  	</ul>
		</div>
		<br><br><br>
	
		<div class="table-responsive" style="height: calc(100vh - 159px); overflow-y: scroll; padding-bottom: 100px">
			<table class="table">
				<th class="event"><em class="fa fa-bolt" aria-hidden="true"></em> EVENTS</th>
				<tr class="event-node"><td style="padding: 0"><button type="button" class="btn button-node"><em class="fa fa-plus" aria-hidden="true"></em></button> <em class="fa fa-map-pin" aria-hidden="true"></em> TAG ENTERED ZONE</td></tr>

				<th class="logic"><em class="fa fa-cogs" aria-hidden="true"></em> LOGIC</th>
				<tr class="logic-node"><td style="padding: 0"><button type="button" class="btn button-node"><em class="fa fa-plus" aria-hidden="true"></em></button> <em class="fa fa-tag" aria-hidden="true"></em> CONDITIONAL</td></tr>
				<tr class="logic-node"><td style="padding: 0"><button type="button" class="btn button-node"><em class="fa fa-plus" aria-hidden="true"></em></button><i class="fa fa-location-arrow" aria-hidden="true"></i> TAG PERIMETER</td></tr>
				<tr class="logic-node"><td style="padding: 0"><button type="button" class="btn button-node"><em class="fa fa-plus" aria-hidden="true"></em></button><i class="fa fa-crosshairs" aria-hidden="true"></i> GEOFENCE</td></tr>
				<tr class="logic-node"><td style="padding: 0"><button type="button" class="btn button-node"><em class="fa fa-plus" aria-hidden="true"></em></button><i class="fa fa-exchange" aria-hidden="true"></i> SWITCH</td></tr>
				<tr class="logic-node"><td style="padding: 0"><button type="button" class="btn button-node"><em class="fa fa-plus" aria-hidden="true"></em></button><i class="fa fa-check" aria-hidden="true"></i> VALIDATE</td></tr>
				<tr class="logic-node"><td style="padding: 0"><button type="button" class="btn button-node"><em class="fa fa-plus" aria-hidden="true"></em></button><i class="fa fa-lock" aria-hidden="true"></i> LOCK</td></tr>
				<tr class="logic-node"><td style="padding: 0"><button type="button" class="btn button-node"><em class="fa fa-plus" aria-hidden="true"></em></button><i class="fa fa-id-card" aria-hidden="true"></i> GENERATE ID</td></tr>
				<tr class="logic-node"><td style="padding: 0"><button type="button" class="btn button-node"><em class="fa fa-plus" aria-hidden="true"></em></button><i class="fa fa-refresh" aria-hidden="true"></i> LOOP</td></tr>
				<tr class="logic-node"><td style="padding: 0"><button type="button" class="btn button-node"><em class="fa fa-plus" aria-hidden="true"></em></button><i class="fa fa-check-square-o" aria-hidden="true"></i> CYCLE COUNT</td></tr>
				<tr class="logic-node"><td style="padding: 0"><button type="button" class="btn button-node"><em class="fa fa-plus" aria-hidden="true"></em></button><i class="fa fa-power-off" aria-hidden="true"></i> POWER DOWN</td></tr>
				<tr class="logic-node"><td style="padding: 0"><button type="button" class="btn button-node"><em class="fa fa-plus" aria-hidden="true"></em></button><i class="fa fa-pause" aria-hidden="true"></i> PAUSE</td></tr>
	
				<th class="data"><i class="fa fa-table" aria-hidden="true"></i> DATA</th>
				<tr class="data-node"><td style="padding: 0"><button type="button" class="btn" style="margin: 0 10px 0 0"><em class="fa fa-plus" aria-hidden="true"></em></button> <em class="fa fa-database" aria-hidden="true"></em> DATABASE</td></tr>
				<tr class="data-node"><td style="padding: 0"><button type="button" class="btn" style="margin: 0 10px 0 0"><em class="fa fa-plus" aria-hidden="true"></em></button><i class="fa fa-bar-chart" aria-hidden="true"></i> GAUGE QUERY</td></tr>
				<tr class="data-node"><td style="padding: 0"><button type="button" class="btn" style="margin: 0 10px 0 0"><em class="fa fa-plus" aria-hidden="true"></em></button><i class="fa fa-pencil-square" aria-hidden="true"></i> UPDATE FILE</td></tr>
				<tr class="data-node"><td style="padding: 0"><button type="button" class="btn" style="margin: 0 10px 0 0"><em class="fa fa-plus" aria-hidden="true"></em></button><i class="fa fa-check-square" aria-hidden="true"></i> GROUP COUNT</td></tr>
				<tr class="data-node"><td style="padding: 0"><button type="button" class="btn" style="margin: 0 10px 0 0"><em class="fa fa-plus" aria-hidden="true"></em></button><i class="fa fa-caret-square-o-left" aria-hidden="true"></i> OLD VALUE</td></tr>
				<tr class="data-node"><td style="padding: 0"><button type="button" class="btn" style="margin: 0 10px 0 0"><em class="fa fa-plus" aria-hidden="true"></em></button><i class="fa fa-caret-square-o-right" aria-hidden="true"></i> NEW VALUE</td></tr>
		
				<th class="output"><em class="fa fa-arrow-right" aria-hidden="true"></em> OUTPUT</th>
				<tr class="output-node"><td style="padding: 0"><button type="button" class="btn" style="margin: 0 10px 0 0"><em class="fa fa-plus" aria-hidden="true"></em></button> <em class="fa fa-envelope" aria-hidden="true"></em> EMAIL</td> </tr>
				<tr class="output-node"><td style="padding: 0"><button type="button" class="btn" style="margin: 0 10px 0 0"><em class="fa fa-plus" aria-hidden="true"></em></button> <em class="fa fa-commenting" aria-hidden="true"></em> SMS</td> </tr>
				<tr class="output-node"><td style="padding: 0"><button type="button" class="btn" style="margin: 0 10px 0 0"><em class="fa fa-plus" aria-hidden="true"></em></button> <em class="fa fa-pencil" aria-hidden="true"></em> RECORD EVENT</td> </tr>
			</table>
		</div>
	</div>
	
	<div class="col-sm-7" id="grid" style="background-image: url(assets/images/map_bg.png)">
		*HERE IS WHERE THE BPMN NODES GO*
	</div>
	
	<div class="col-sm-3">
		*HERE IS WHERE NODE DETAILS GO*
	</div>
</div>

<!--
	<div *ngIf="workflow.event != null" style="color: #ffffff; margin: 20px 20px 20px 0">
	<div class="row">
		<div class="col-sm-3">
			<div class="panel panel-drk-ornge">
				<div class="panel-body" style="height: 190px; overflow: hidden; max-height: 100%">
					<i class="fa fa-4x fa-4x {{getGlpyhForEvent(workflow.event)}}" aria-hidden="true" style="color: #f57300"></i>
					<h3 style="overflow: hidden">{{workflow.event.name}}</h3>
					<h4 style="overflow: hidden">{{workflow.event.description}}</h4>
				</div>
				<div class="panel-footer panel-drk-ornge">
					<button (click)="selectEvent(null); mEventsPageNumber = 1;" class="btn btn-ef" style="width: 100%" >REMOVE</button>
				</div>
			</div>
		</div>
	</div>
</div>

<br/>


<ng-container *ngIf="workflowNodes != null">
	<ng-container *ngFor="let node of workflowNodes">
		<div class="col-sm-9">
			<div class="panel panel-drk-ornge">
				<ng-container [ngSwitch]="node.type">
					<app-workflow-service-node *ngSwitchCase="'SERVICE'"
						[node]="node" >
					</app-workflow-service-node>
		
					<app-workflow-log-node *ngSwitchCase="'LOG'"
						[node]="node" >
					</app-workflow-log-node>

					<app-workflow-loop-node *ngSwitchCase="'LOOP'"
						[node]="node" >
					</app-workflow-loop-node>
				
					<div *ngSwitchDefault>
						<p>WTF</p>
					</div>
				</ng-container>
			</div>
		</div>
	</ng-container>

</ng-container>
-->